import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TableComponent from '~/components/TableComponent';
import i18n from '~/components/i18n';
import { Loader } from 'semantic-ui-react';
import { El as LayoutEl } from '~/components/Layout/style';
import CreateEditFeedSupplier from './CreateEditFeedSupplier';
import ClimaProgramQuery from '~/QueryHooks/ClimaProgramQuery';

const getTableColumns = () => [
  {
    name: i18n.t('Name'),
    key: 'name'
  },
  {
    name: i18n.t('Status'),
    key: 'statusLabel'
  },
  {
    name: i18n.t('Actions')
  }
];

const FeedSuppliers: React.FC = () => {
  const { t } = useTranslation();

  const [dataFiltered, setDataFiltered] = useState({
    page: 0,
    rows: 20
  })
  const [drawer, setDrawerState] = useState({
    isVisible: false,
    id: null as number | null
  });

  const {
    isLoading: isBusy,
    data: feedSuppliersData,
    isFetching: isFetchingSuppliers,
    refetch: fetchData
  } = ClimaProgramQuery.getFeedSuppliers({
    ...dataFiltered,
    page: dataFiltered.page === 0 ? dataFiltered.page : dataFiltered.page - 1
  });

  useEffect(() => {
    fetchData()
  }, [dataFiltered])

  const { filtered, rows } = feedSuppliersData ? feedSuppliersData : { filtered: 0, rows: [] };

  const feedSuppliers = rows.map(item => ({
    ...item,
    statusLabel: item.status ? t('Active') : t('Inactive')
  }));

  const actions = [
    {
      popupMessage: i18n.t('Edit'),
      type: 'icon',
      name: 'pencil',
      size: 'large',
      actionType: 'edit',
      displayedText: i18n.t('No actions')
    }
  ];

  function handleActionClick(row, type) {
    switch (type) {
      case 'edit':
        return setDrawerState({ isVisible: true, id: row?.id });
      default:
        return;
    }
  }

  function renderTable() {
    return (
      <TableComponent
        tableColumnHeaders={getTableColumns()}
        rows={feedSuppliers || []}
        total={filtered || 0}
        dataFiltered={dataFiltered}
        handleChangeDataFiltered={(dataFiltered) => setDataFiltered(dataFiltered)}
        handleClickAction={handleActionClick}
        animated
        isFetchingData={isFetchingSuppliers}
        actions={actions}
      />
    );
  }

  function renderActions() {
    return (
      <LayoutEl.PageHeaderActionButton
        onClick={() => setDrawerState({ isVisible: true, id: null })}
      >
        {t('Add')}
      </LayoutEl.PageHeaderActionButton>
    );
  }

  function renderEditCreateDrawer() {
    return (
      <CreateEditFeedSupplier
        isVisible={drawer.isVisible}
        idFeedSupplier={drawer.id}
        fetchData={fetchData}
        handleHiddenDrawer={() => setDrawerState({ isVisible: false, id: null })}
      />
    );
  }

  if (isBusy) {
    return <Loader active inline='centered' />;
  }

  return (
    <div>
      <div style={{ marginBottom: '1rem', display: 'flex', justifyContent: 'flex-end' }}>
        {renderActions()}
      </div>
      {renderEditCreateDrawer()}
      {renderTable()}
    </div>
  );
};

export default FeedSuppliers;
